import { render, staticRenderFns } from "./AddCoOwnerForm.vue?vue&type=template&id=5f5be0f7&"
import script from "./AddCoOwnerForm.vue?vue&type=script&lang=js&"
export * from "./AddCoOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./AddCoOwnerForm.vue?vue&type=style&index=0&id=5f5be0f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports